// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const SelectActionsheetVirtualizedList = createStyle({
  w: '$full',
  h: 'auto',
});
